import * as React from 'react';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { useAppSelector } from '../../app/hooks';
import { selectLoggedUser, selectLoggedUserId } from '../user/userSlice';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

interface BadgeAvatarProps {
  firstName: string;
  surname: string;
  userId?: string;
  username?: string;
}

const BadgeAvatar: React.FC<BadgeAvatarProps> = ({ firstName, surname, userId, username }) => {
  const currentUserId = useAppSelector(selectLoggedUserId);
  const currentUsername = useAppSelector(selectLoggedUser);

  const hasUserId = typeof userId === 'string' && userId.length > 0;
  const hasUsername = typeof username === 'string' && username.length > 0;

  const isCurrentUser = hasUserId
    ? currentUserId === userId
    : hasUsername
      ? currentUsername === username
      : false;
  return (
    <Stack direction="row" spacing={2}>
      <StyledBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        variant={isCurrentUser ? "dot" : undefined}
      >
        <Avatar sx={{ mr: 1 }}>{firstName.charAt(0)}{surname.charAt(0)}</Avatar>
      </StyledBadge>
    </Stack>
  );
};

export default BadgeAvatar;
